export default function butterImageLoader({src, width, quality}) {
    const version = process.env.RELEASE_ID || 'v3-default';
    if (src.startsWith('https://cdn.buttercms.com')) {
        return `${src}?calv=${version}`;
    } else {
        return src
    }
}
